import { EPeriodFilter } from '../../../../utils/app-models'

export const alertsDefaultFiltersValues = {
	period: EPeriodFilter.thisMonth,
	status: 'all',
	category: 'all',
}
